import GATSBY_COMPILED_MDX from "/home/develop/pxplanding/data/blog/customer-service-vs-customer-experience-two-approaches-working-together.mdx";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React, {useEffect, useRef, useState} from "react";
import classnames from "classnames";
import {Link} from "gatsby";
import {Content} from "../components/container/container";
import CloseOutlined from "../assets/icons/CloseCircleOutlined.inline.svg";
import Linkedin from "../images/linkedin.inline.svg";
import FB from "../images/facebook.inline.svg";
import Twitter from "../images/twitter.inline.svg";
import {BlogCard} from "../components/blog/Card.component";
import SEO from "../components/seo";
import {EmailInput} from "../components/blog/NewsLetterForm";
import * as styles from "./post.module.css";
import {makeAbsoluteUrl} from "../utility";
import {getImage, GatsbyImage} from "gatsby-plugin-image";
import FooterDetails from "../components/new-components/Footer/FooterDetails/FooterDetails";
import Header from "../components/new-components/Header/Header";
const Tag = _ref => {
  let {name} = _ref;
  return React.createElement(Link, {
    className: styles.tag,
    to: "/blog?category=" + name
  }, name);
};
const makeSocialShareURL = (socialType, title, slug) => {
  switch (socialType) {
    case "facebook":
      return "https://www.facebook.com/sharer/sharer.php?u=" + makeAbsoluteUrl(slug, true, "/blog/post");
    case "linkedin":
      return "https://www.linkedin.com/shareArticle?mini=true&url=" + makeAbsoluteUrl(slug, true, "/blog/post") + "&title=" + title + "&summary=" + title + "&source=";
    case "twitter":
      return "https://twitter.com/intent/tweet?url=" + makeAbsoluteUrl(slug, true, "/blog/post") + "&text=" + title;
  }
};
const SocialLink = _ref2 => {
  let {Logo, slug, socialType, title, height = 400, width = 600} = _ref2;
  return React.createElement("a", {
    target: "_blank",
    onClick: e => window.open(e.currentTarget.href, "targetWindow", "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, top=150, left=0, width=" + width + ", height=" + height),
    href: makeSocialShareURL(socialType, title, slug)
  }, React.createElement(Logo, null));
};
const shuffle = list => {
  const copy = _toConsumableArray(list);
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
};
const CardInfo = _ref3 => {
  let {children, title} = _ref3;
  return React.createElement("div", {
    className: styles.cardInfo
  }, React.createElement("span", {
    className: styles.CardInfoTitle
  }, title), React.createElement("span", {
    className: styles.CardInfoBody
  }, children));
};
const Blog = _ref4 => {
  let {children, pageContext: data} = _ref4;
  const {author, date, time, title, categories} = data.frontmatter;
  const related = React.useMemo(() => data.related.length > 0 && (data.related.length > 3 ? shuffle(data.related).slice(0, 3) : data.related), [data]);
  const bodyRef = useRef(null);
  const {0: showNewsLetter, 1: setShowNewsLetter} = useState(false);
  const {0: shouldShowNewsletter, 1: setShouldShowNewsletter} = useState(true);
  useEffect(() => {
    if (shouldShowNewsletter) {
      const scrollCallback = () => {
        if (bodyRef.current) {
          const fullHeight = bodyRef.current.scrollHeight - bodyRef.current.offsetHeight;
          const top = bodyRef.current.scrollTop;
          if (top >= 0.95 * fullHeight || top < 0.4 * fullHeight) {
            setShowNewsLetter(false);
          } else if (top > fullHeight * 0.4) {
            setShowNewsLetter(true);
          }
        }
      };
      if (bodyRef.current) {
        if (shouldShowNewsletter) {
          bodyRef.current.addEventListener("scroll", scrollCallback);
        } else {
          bodyRef.current.removeEventListener("scroll", scrollCallback);
        }
      }
      return () => {
        if (bodyRef.current) {
          bodyRef.current.removeEventListener("scroll", scrollCallback);
        }
      };
    }
  }, [bodyRef, shouldShowNewsletter]);
  const closeNewsletterBox = () => {
    setShowNewsLetter(false);
    setShouldShowNewsletter(false);
  };
  const image = getImage(data.image);
  return React.createElement("div", {
    className: classnames(styles.post, "fancy-scroll"),
    ref: bodyRef
  }, React.createElement(Header, null), React.createElement("div", {
    className: styles.infoContainer
  }, image && React.createElement(GatsbyImage, {
    className: styles.info__image,
    image: image,
    alt: title
  }), React.createElement("div", {
    className: styles.info
  }, React.createElement("h1", {
    className: styles.title
  }, title), React.createElement("div", {
    className: styles.author
  }, "By: ", author), React.createElement("div", {
    className: styles.dateContainer
  }, React.createElement("span", {
    className: styles.date
  }, date), React.createElement("span", {
    className: styles.separator
  }, "|"), React.createElement("span", null, time, " min read")))), React.createElement("div", {
    className: styles.bottom
  }, React.createElement("div", {
    className: styles.content
  }, React.createElement(Content, null, children), React.createElement("div", null, categories.map(x => React.createElement(Tag, {
    key: x,
    name: x
  })))), React.createElement("div", {
    className: classnames(styles.authorContainer, styles.dashedBorder)
  }, React.createElement(CardInfo, {
    title: "author"
  }, React.createElement("div", {
    className: styles.profile
  }, React.createElement("img", {
    src: data.profile,
    alt: author
  }), React.createElement("span", null, author))), React.createElement(CardInfo, {
    title: "share"
  }, React.createElement("div", {
    className: styles.socials
  }, React.createElement(SocialLink, {
    Logo: Twitter,
    slug: data.slug,
    socialType: "twitter",
    title: title
  }), React.createElement(SocialLink, {
    Logo: Linkedin,
    slug: data.slug,
    socialType: "linkedin",
    title: title,
    height: 505,
    width: 475
  }), React.createElement(SocialLink, {
    Logo: FB,
    slug: data.slug,
    socialType: "facebook",
    title: title
  })))), related && React.createElement("div", {
    className: classnames(styles.related, styles.dashedBorder)
  }, React.createElement("h4", null, "Related Articles"), React.createElement("div", {
    className: styles.cards
  }, related.map(p => p && React.createElement(BlogCard, {
    key: p.slug,
    post: {
      author: p.content.childMdx.frontmatter.author,
      categories: p.content.childMdx.frontmatter.categories,
      date: p.content.childMdx.frontmatter.date,
      slug: p.slug,
      summary: p.content.childMdx.frontmatter.summary,
      time: p.content.childMdx.frontmatter.time,
      title: p.content.childMdx.frontmatter.title,
      image: getImage(p.image)
    }
  })))), React.createElement(FooterDetails, {
    name: title,
    section: "Blog",
    slug: "/blog/post/" + data.slug
  })), showNewsLetter && React.createElement("div", {
    className: styles.newsletter
  }, React.createElement("div", {
    className: styles.newsletter__content
  }, React.createElement("div", {
    className: styles.newsletter__title
  }, "Signup to our newsletter"), React.createElement(EmailInput, {
    referred: {
      url: "blog/post/" + data.slug,
      name: title,
      section: "Blog"
    },
    radius: 60
  })), React.createElement("span", {
    onClick: closeNewsletterBox,
    className: styles.xButton
  }, React.createElement(CloseOutlined, null))));
};
Blog
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Blog, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref5 => {
  var _pageContext$frontmat;
  let {pageContext} = _ref5;
  const {author, date, description, keywords, title, summary} = pageContext.frontmatter;
  const dateTime = React.useMemo(() => new Date(date).toISOString(), [date]);
  const image = (_pageContext$frontmat = pageContext.frontmatter.image) === null || _pageContext$frontmat === void 0 ? void 0 : _pageContext$frontmat.publicURL;
  return React.createElement(SEO, {
    title: title,
    description: description || summary,
    image: image,
    type: "article",
    meta: [{
      id: "author",
      name: "author",
      property: "author",
      content: author
    }, {
      id: "article_author",
      name: "article_author",
      property: "article:author",
      content: author
    }, {
      id: "publish_date",
      name: "publish_date",
      content: dateTime,
      property: "og:publish_date"
    }, {
      id: "article_publish_date",
      name: "article_publish_date",
      content: dateTime,
      property: "article:published_time"
    }, {
      name: "keywords",
      content: keywords === null || keywords === void 0 ? void 0 : keywords.join(",")
    }]
  });
};
